(function () {
    // Grab the posts container.
    const postsContainer = document.getElementById('post-grid-posts');
    if (!postsContainer) {
        return;
    }

    /**
     * Fetch posts via AJAX and update the posts container.
     *
     * @param {string} url The URL to fetch.
     */
    function fetchPosts(url) {
        const ajaxUrl = new URL(url, window.location.href);
        ajaxUrl.searchParams.set('ajax', '1');

        fetch(ajaxUrl.toString(), {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                }
                throw new Error('Network response was not ok.');
            })
            .then(function (html) {
                // Parse the returned HTML string so we can extract the new posts container.
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newPostsContainer = doc.getElementById('enhanced-posts-grid-posts');
                if (newPostsContainer) {
                    // Replace the inner HTML of the posts container.
                    postsContainer.innerHTML = newPostsContainer.innerHTML;
                    // Optionally update the browser address bar.
                    history.pushState(null, '', url);
                }
            })
            .catch(function (error) {
                console.error('Fetch error: ', error);
            });
    }

    // Delegate click events on pagination links within the posts container.
    postsContainer.addEventListener('click', function (event) {
        const target = event.target;
        if (target.tagName.toLowerCase() === 'a' && target.closest('.post-grid-pagination')) {
            event.preventDefault(); // Prevent default navigation.
            fetchPosts(target.href);
        }
    });

    // Listen for filter form submissions.
    const filterForm = document.getElementById('post-grid-filter-form');
    if (filterForm) {
        filterForm.addEventListener('submit', function (event) {
            event.preventDefault();
            // Build a new URL based on the form data.
            const formData = new FormData(filterForm);
            const url = new URL(window.location.href);
            // Remove any previous filter parameters.
            url.searchParams.delete('search');
            url.searchParams.delete('category');
            // Append the form values.
            for (const [key, value] of formData.entries()) {
                if (value) {
                    url.searchParams.set(key, value);
                } else {
                    url.searchParams.delete(key);
                }
            }
            // Reset pagination to the first page.
            url.searchParams.set('paged', '1');
            fetchPosts(url.toString());
        });
    }
})();
